<template>
  <RevInfoBlock
    :caption="warrantyStateTranslation"
    class="bg-static-warning-low"
    :icon="IconWarning"
    :title="i18n(translations.title)"
    variant="warning"
  >
    <CustomerIssues v-if="customerIssues.length" :customer-issues />

    <LabelReturn v-if="labelReturn" :label-return />
  </RevInfoBlock>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import type {
  DeclaredWarrantyState,
  LabelReturn as LabelReturnType,
} from '~/api/care-folders/types/claim'
import type { CustomerIssue } from '~/api/care-folders/types/common'

import CustomerIssues from '../CustomerIssues/CustomerIssues.vue'
import LabelReturn from '../LabelReturn/LabelReturn.vue'

import translations from './OutOfWarrantyInfoBlock.translations'

const i18n = useI18n()

const props = defineProps<{
  customerIssues: CustomerIssue[]
  warrantyState?: DeclaredWarrantyState | null
  labelReturn: LabelReturnType | null
}>()

const warrantyStateTranslation = computed(() => {
  switch (props.warrantyState) {
    case 'WATER_OR_DROPPED':
      return i18n(translations.waterOrDropped)
    case 'THIRD_PARTY_REPAIR':
      return i18n(translations.thirdPartyRepair)
    default:
      return ''
  }
})
</script>
